import template from './einzelticketcode.html';
import controller from './einzelticketcode.controller';
import './einzelticketcode.scss';

let einzelticketcodeComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default einzelticketcodeComponent;



// WEBPACK FOOTER //
// ./client/app/common/forms/einzelticketcode/einzelticketcode.component.js